import { AsyncPipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { LoadingService } from '../../../utilities/services/loading/loading.service';

@Component({
  selector: 'stupa-gif-loader',
  standalone: true,
  imports: [NgIf, AsyncPipe],
  templateUrl: './gif-loader.component.html',
  styleUrls: ['./gif-loader.component.scss']
})
export class GifLoaderComponent {
  constructor(private readonly loadingService: LoadingService) {}
  isGlobalLoading$ = this.loadingService.isLoading$;
}
